import clsx from 'clsx'
import { Checkbox, Grid, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'components/Chart/ChartLegend/ChartLegend.module.scss'

export const ChartLegend = ({
  className = '',
  metrics = [],
  handleClick = () => {},
  colors = [],
}) => {
  const { t } = useTranslation(['pulse'])

  return (
    <Grid
      gap={24}
      className={clsx(styles['chart-legend'], className)}
      wrap={'nowrap'}
    >
      {metrics.map(({ id, isHidden }, index) => (
        <div
          key={id}
          className={clsx(styles['chart-legend__item'], {
            [styles['chart-legend__item_hidden']]: isHidden,
          })}
        >
          <span
            className={styles['chart-legend__link']}
            onClick={() => handleClick(id)}
          >
            <div className={styles['chart-legend__link-icon']}>
              <Checkbox
                fillColor={colors[index]}
                checked={!isHidden}
                onClick={() => handleClick(id)}
              />
            </div>
            <Typography
              variant={'Body-15'}
              className={styles['chart-legend__link-text']}
            >
              {t(`chart.legend.labels.${id}`)}
            </Typography>
          </span>
        </div>
      ))}
    </Grid>
  )
}

ChartLegend.defaultProps = {
  className: '',
  metrics: [],
  handleClick: () => {},
  colors: [],
}

ChartLegend.propTypes = {
  className: PropTypes.string,
  metrics: PropTypes.array,
  handleClick: PropTypes.func,
  colors: PropTypes.array,
}
